import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { SquareImage } from '@tbitop/ui';
import { useEffect, useState } from 'react';

type VersionsanzeigeProps = {
  logoUrl: string;
  organisation: string;
  appName: string;
  clientVersion: string;
  apiVersion: string;
};

export const Versionsanzeige = ({ apiVersion, clientVersion, logoUrl, organisation, appName }: VersionsanzeigeProps) => {
  const [bundleVersion, setBundleVersion] = useState<string>('');

  useEffect(() => {
    loadBundleVersion();
  }, []);

  async function loadBundleVersion() {
    const currentBundle = await CapacitorUpdater.current();
    if (currentBundle?.bundle.version) {
      setBundleVersion(currentBundle.bundle.version);
    }
  }

  return (
    <div className="flex mb-4 mx-3.5">
      <SquareImage alt="Applikationslogo" scale={96} src={logoUrl} />
      <div className="pl-4">
        <div className="text-base font-bold leading-tight text-medium">{organisation}</div>
        <div className="text-2xl font-bold leading-tight text-dark">{appName}</div>
        <div className="text-sm text-dark">Frontend: {clientVersion}</div>
        <div className="text-sm text-dark">Backend: {apiVersion}</div>
        {bundleVersion ? <div className="text-sm text-dark">Bundle: {bundleVersion}</div> : null}
      </div>
    </div>
  );
};
